import React from 'react'
import { Globe, Activity, Gift, Smartphone, ArrowRight } from 'lucide-react'

interface PortfolioItem {
  icon: React.ComponentType<{ className?: string }>
  category: string
  title: string
  link: string
}

const portfolioItems: PortfolioItem[] = [
  {
    icon: Globe,
    category: "Non-Profit Organization",
    title: "Growing Together OPC",
    link: "https://growingtogether-int.org"
  },
  {
    icon: Activity,
    category: "Healthcare Application",
    title: "Dentist Pro",
    link: "https://dentistpro.app"
  },
  {
    icon: Gift,
    category: "Interactive Web App",
    title: "Surprise For Chan",
    link: "https://surpriseforchan.vercel.app/"
  },
  {
    icon: Smartphone,
    category: "Mobile-First Demo",
    title: "Appever Demo",
    link: "https://appever-nextjs.vercel.app/"
  }
]

interface PortfolioSectionProps {
  className?: string
}

export default function PortfolioSection({ className }: PortfolioSectionProps) {
  return (
    <section className={`relative z-10 py-24 container mx-auto px-8 md:px-16 ${className}`}>
      <h2 className="text-3xl md:text-5xl font-bold mb-16">It's Our Portfolio</h2>
      <div className="space-y-6">
        {portfolioItems.map((item, i) => (
          <div key={i} className="group flex flex-col md:flex-row items-center gap-6 p-6 rounded-2xl bg-white/5 border border-white/5 hover:border-indigo-500/30 transition-all hover:bg-white/10">
            <div className="w-16 h-16 bg-slate-800 rounded-xl flex items-center justify-center shrink-0">
              <item.icon className="w-8 h-8 text-indigo-400" />
            </div>
            <div className="flex-1 text-center md:text-left">
              <div className="text-sm font-medium text-slate-400 mb-1">{item.category}</div>
              <h3 className="text-xl md:text-2xl font-bold text-white group-hover:text-indigo-300 transition-colors">{item.title}</h3>
            </div>
            <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-6 py-3 rounded-full border border-white/10 text-sm font-medium text-slate-300 hover:text-white hover:bg-white/5 transition-all whitespace-nowrap"
            >
              View project <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        ))}
      </div>
    </section>
  )
}
